/**
* Rank-Push content — unique long-form sections + FAQs used by the top-6 pages
* targeted for GSC page 1-5 push. Keep every string factual, on-brand, and
* anchored to real services/prices from the site.
*/

export const BANGKOK_NOTARY_SECTIONS = [
  {
    heading: "Bangkok Notary Service — บริการ Notary Public ในกรุงเทพฯ ครบวงจร",
    body: [
      "Thai Notary Law & Service ให้บริการ Notary Public ในกรุงเทพมหานครทั้ง 50 เขต ครอบคลุมทั้งการรับรองลายมือชื่อ (Signature Certification), รับรองสำเนาถูกต้อง (Certified True Copy), รับรองคำแปล (Notarized Translation), รับรองคำสาบาน (Affidavit) และรับรองเอกสารสำหรับใช้ในต่างประเทศ",
      "ทนายผู้ให้บริการทั้ง 6 ท่านได้รับใบอนุญาต Notarial Services Attorney จากสภาทนายความในพระบรมราชูปถัมภ์ ตามข้อบังคับ พ.ศ. 2551 พร้อมประสบการณ์รวมกันมากกว่า 60 ปี ให้บริการทั้งภาษาไทย อังกฤษ จีน ญี่ปุ่น เกาหลี เวียดนาม และอินโดนีเซีย",
    ],
  },
  {
    heading: "จุดแข็งที่ทำให้ลูกความเลือกเรา",
    bullets: [
      "รับด่วนภายในวันเดียว — ยื่นเช้า เสร็จบ่าย (บริการนอกสถานที่ในกรุงเทพฯ ทุกเขต)",
      "ทนายเดินทางไปพบที่ออฟฟิศ โรงแรม หรือคอนโดของลูกความได้ตลอด 7 วัน",
      "แจ้งค่าบริการและค่าธรรมเนียมบุคคลภายนอกเป็นลายลักษณ์อักษรก่อนเริ่มงาน",
      "รองรับ Apostille + MFA + Embassy Legalization ครบวงจร (ยื่นแทนได้)",
      "ใบเสร็จรับเงินและใบกำกับภาษีถูกต้องตามกรมสรรพากร",
    ],
  },
  {
    heading: "เอกสารที่รับรอง Notary Public บ่อยที่สุดในกรุงเทพฯ",
    bullets: [
      "หนังสือมอบอำนาจ (Power of Attorney) — สำหรับใช้ในต่างประเทศ",
      "Affidavit / Statutory Declaration — ยื่นสถานทูตต่างประเทศ",
      "Certified True Copy of Passport / ID Card / Degree Certificate",
      "หนังสือรับรองบริษัท + งบการเงิน (สำหรับตั้งบริษัทต่างประเทศ / เปิดบัญชี)",
      "สัญญาระหว่างประเทศ (International Contracts), MOU, NDA",
      "Notarized Translation ไทย ↔ อังกฤษ / จีน / ญี่ปุ่น / เกาหลี",
      "เอกสารสมัครวีซ่านักเรียน / วีซ่าทำงาน / วีซ่าคู่หมั้น",
    ],
  },
];

export const BANGKOK_NOTARY_FAQ = [
  {
    question: "Bangkok notary service ราคาเท่าไหร่?",
    answer:
    "ค่าบริการ Notary Public สอบถามค่าบริการ เป็นรายกรณี สำหรับรับรองสำเนาถูกต้องหรือลายมือชื่อ ส่วนงานแปลรับรอง Notarized Translation สอบถามค่าบริการ เป็นรายกรณี ราคาโปร่งใส ไม่มีค่าใช้จ่ายแอบแฝง ค่าเดินทางนอกสถานที่ในกรุงเทพฯ สอบถามค่าบริการ",
  },
  {
    question: "ทนาย Notary Public ในกรุงเทพฯ สามารถเดินทางมาที่ออฟฟิศได้หรือไม่?",
    answer:
      "ได้ครับ เราให้บริการ Notary Public นอกสถานที่ครอบคลุม 50 เขตในกรุงเทพฯ ทนายเดินทางไปพบลูกความที่ออฟฟิศ โรงแรม คอนโด หรือธนาคาร นัดล่วงหน้าอย่างน้อย 1 วันทำการผ่าน LINE หรือโทรศัพท์",
  },
  {
    question: "เอกสารที่ผ่าน Notary Public ในไทยใช้ในต่างประเทศได้เลยหรือไม่?",
    answer:
      "หลังจากรับรอง Notary Public แล้ว เอกสารส่วนใหญ่ต้องผ่านการรับรอง Legalization เพิ่มเติมที่กรมการกงสุล กระทรวงการต่างประเทศ (MFA) และสถานทูตปลายทาง เราให้บริการยื่นแทนได้ทั้งหมด เสร็จภายใน 3-7 วันทำการ",
  },
  {
    question: "รับรองสำเนาถูกต้อง (Certified True Copy) ในไทยใช้ที่ไหนได้บ้าง?",
    answer:
      "Certification of copies โดย Notary Public ในไทย ใช้ได้กับหน่วยงานราชการต่างประเทศ, สถานทูต, มหาวิทยาลัยต่างประเทศ, ธนาคารระหว่างประเทศ และการจดทะเบียนบริษัทในต่างประเทศ หลังผ่าน MFA + Embassy Legalization",
  },
  {
    question: "Document legalization Thailand ใช้เวลานานเท่าไหร่?",
    answer:
      "ขั้นตอน Legalization เอกสารในไทยใช้เวลา 3-7 วันทำการ ประกอบด้วย: (1) Notary Public 1 วัน (2) กระทรวงการต่างประเทศ 2-3 วัน (3) สถานทูตปลายทาง 1-3 วัน สามารถบริการด่วน (Express) เสร็จภายใน 24-48 ชั่วโมงในบางประเทศ",
  },
  {
    question: "รับ Notary Public วันเสาร์-อาทิตย์ได้หรือไม่?",
    answer:
      "ได้ครับ ทีมทนายของเรารับนัดหมายวันเสาร์-อาทิตย์และวันหยุดนักขัตฤกษ์ในกรุงเทพฯ สำหรับงานด่วน โปรดนัดหมายล่วงหน้าผ่าน LINE Official Account หรือโทรศัพท์",
  },
  {
    question: "รองรับภาษาอะไรบ้าง?",
    answer:
      "ทีมทนายและล่ามรองรับ 7 ภาษา ได้แก่ ไทย, อังกฤษ, จีนกลาง, ญี่ปุ่น, เกาหลี, เวียดนาม และอินโดนีเซีย ทั้งบริการ Notary Public และงานแปลรับรอง Notarized Translation",
  },
];

export const ABOUT_FAQ = [
  {
    question: "Thai Notary Law & Service Co., Ltd. จดทะเบียนถูกต้องหรือไม่?",
    answer:
      "เราเป็นนิติบุคคลจดทะเบียนถูกต้อง มีใบทะเบียนพาณิชย์และใบทะเบียนภาษีมูลค่าเพิ่ม (VAT) ครบถ้วน ออกใบกำกับภาษีได้ตามกฎหมาย",
  },
  {
    question: "ทนาย Notary Public ของบริษัทมีใบอนุญาตจากไหน?",
    answer:
      "ทนายทั้ง 6 ท่านได้รับใบอนุญาต Notarial Services Attorney จากสภาทนายความในพระบรมราชูปถัมภ์ (Lawyers Council of Thailand) ตามข้อบังคับว่าด้วยการขึ้นทะเบียนทนายความผู้ทำคำรับรองลายมือชื่อและเอกสาร พ.ศ. 2551",
  },
  {
    question: "ทำไมต้องเลือก Thai Notary Law มากกว่าสำนักงานอื่น?",
    answer:
      "เรามีสำนักงานจริง 4 สาขา (กรุงเทพฯ ขอนแก่น อุดรธานี หนองคาย) ทีมทนาย 6 ท่านให้บริการ 7 ภาษา ประสบการณ์รวมกันกว่า 60 ปี เชี่ยวชาญเฉพาะทางด้าน Notary Public แปลรับรอง วีซ่า และกฎหมายระหว่างประเทศ",
  },
  {
    question: "ให้บริการต่างจังหวัดได้หรือไม่?",
    answer:
      "ได้ครับ เราให้บริการทั่วประเทศไทยครอบคลุมทั้ง 77 จังหวัด ผ่านเครือข่ายทนายพันธมิตร และบริการออนไลน์สำหรับลูกความต่างประเทศ",
  },
];
